import { Controller } from '@hotwired/stimulus'

// "Alle/Keine wählen"-Helfer für die EBMS-Import-Checkbox-Liste.
// Markup: <div data-controller="ebms-import"> mit
//   data-action="ebms-import#selectAll"  /  "ebms-import#selectNone"
// auf den Buttons und data-ebms-import-target="checkbox" auf jeder Checkbox.
export default class extends Controller {
  static targets = ['checkbox']

  selectAll() {
    this.checkboxTargets.forEach(cb => { cb.checked = true })
  }

  selectNone() {
    this.checkboxTargets.forEach(cb => { cb.checked = false })
  }
}
